import mitt from 'mitt'
import { createAiEmployeeConsoleStore } from './aiEmployeeConsole'

export const NEW_AI_EMPLOYEE_CONSOLE_APP_NAME = 'newcrae-ai-employee-console'
export const NEW_AI_EMPLOYEE_CONSOLE_RESET_EVENT = 'newcrae-ai-employee-console:reset'
export const NEW_AI_EMPLOYEE_CONSOLE_PREFIX = '/newcrae-ai-employee'

// 新控制台使用独立总线，保活的旧控制台不会收到新入口的路由和会话事件。
const emitter = mitt<Record<string, any>>()
export interface ConsoleEventBus {
  $on: (event: string, handler: (payload: any) => void) => void
  $off: (event: string, handler: (payload: any) => void) => void
  $emit: (event: string, payload?: any) => void
}
export const newAiEmployeeConsoleBus: ConsoleEventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
}

export const useNewAiEmployeeConsoleStore = createAiEmployeeConsoleStore(
  'newAiEmployeeConsole',
  NEW_AI_EMPLOYEE_CONSOLE_PREFIX,
  '新AI员工',
  NEW_AI_EMPLOYEE_CONSOLE_RESET_EVENT,
)
